var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWarningMini = function SvgWarningMini(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10412_23075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00014 1.88259L0.884386 8.75352C0.799529 8.90047 0.754629 9.06708 0.754154 9.23678C0.753679 9.40647 0.797645 9.57333 0.881678 9.72076C0.965711 9.86818 1.08688 9.99104 1.23314 10.0771C1.37939 10.1632 1.54563 10.2094 1.71531 10.2113H9.94682C10.1165 10.2094 10.2827 10.1632 10.429 10.0771C10.5752 9.99104 10.6964 9.86818 10.7805 9.72076C10.8645 9.57333 10.9085 9.40647 10.908 9.23678C10.9075 9.06708 10.8626 8.90047 10.7777 8.75352L6.66199 1.88259C6.57536 1.73978 6.45339 1.62171 6.30785 1.53977C6.1623 1.45782 5.99809 1.41477 5.83106 1.41477C5.66404 1.41477 5.49983 1.45782 5.35428 1.53977C5.20873 1.62171 5.08676 1.73978 5.00014 1.88259V1.88259Z",
    stroke: "#EB5757",
    strokeWidth: 0.971842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83105 4.38013V6.32381",
    stroke: "#EB5757",
    strokeWidth: 0.971842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83105 8.2675H5.83591",
    stroke: "#EB5757",
    strokeWidth: 0.971842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10412_23075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6621,
    height: 11.6621,
    fill: "white",
    transform: "translate(0 0.00683594)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningMini, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-mini.0085e374.svg";
export { ForwardRef as ReactComponent };